import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddCustomerEmployeeInput, ChangePasswordInput, ChangePersonalInformationInput, CustomerEmployeeFullResult, CustomerEmployeeResult, EditCustomerEmployeeInput, EmailResult, ForgotPasswordInput, GetCustomerEmployeesInput, LoginInput, LoginResult, Result, ResultList, SingleResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class CustomerEmployeeService {

  constructor(private httpClient: HttpClient) { }

  public addCustomerEmployee(addCustomerEmployeeInput: AddCustomerEmployeeInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'CustomerEmployee/AddCustomerEmployee', addCustomerEmployeeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editCustomerEmployee(id: number, editCustomerEmployeeInput: EditCustomerEmployeeInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'CustomerEmployee/EditCustomerEmployee?id=' + id, editCustomerEmployeeInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteCustomerEmployee(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'CustomerEmployee/DeleteCustomerEmployee?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getCustomerEmployees(getCustomerEmployeesInput: GetCustomerEmployeesInput): Promise<ResultList<CustomerEmployeeResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'CustomerEmployee/GetCustomerEmployees', getCustomerEmployeesInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerEmployeeResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerEmployeeResult>(), result.error));
  }

  public getCustomerEmployee(id: number, token: string): Promise<SingleResult<CustomerEmployeeFullResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'CustomerEmployee/GetCustomerEmployee?id=' + id, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<CustomerEmployeeFullResult>(CustomerEmployeeFullResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<CustomerEmployeeFullResult>(CustomerEmployeeFullResult), result.error));
  }

  public getAllEmails(customerId: number, token: string): Promise<ResultList<EmailResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'CustomerEmployee/GetAllEmails?customerId=' + customerId, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<EmailResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<EmailResult>(), result.error));
  }

  public getCustomerEmployeeInformationByTicketId(ticketId: number): Promise<ResultList<CustomerEmployeeFullResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'CustomerEmployee/GetCustomerEmployeeInformationByTicketId?ticketId=' + ticketId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<CustomerEmployeeFullResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<CustomerEmployeeFullResult>(), result.error));
  }

  public forgotPassword(forgotPasswordInput: ForgotPasswordInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'CustomerEmployee/ForgotPassword', forgotPasswordInput, Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public changePersonalInformation(id: number, changePersonalInformationInput: ChangePersonalInformationInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'CustomerEmployee/ChangePersonalInformation?id=' + id, changePersonalInformationInput, Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public changePassword(id: number, changePasswordInput: ChangePasswordInput): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'CustomerEmployee/ChangePassword?id=' + id, changePasswordInput, Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public login(loginInput: LoginInput): Promise<SingleResult<String>> {
    return this.httpClient.post(Utility.serviceAddress + 'CustomerEmployee/Login', loginInput, Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<String>(String), result))
      .catch(result => plainToClassFromExist(new SingleResult<String>(String), result.error));
  }

  public logout(): Promise<Result> {
    return this.httpClient.get(Utility.serviceAddress + 'CustomerEmployee/Logout', Utility.options('token'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public checkPermission(): Promise<SingleResult<LoginResult>> {
    const token = localStorage.getItem('token');
    if (token != null)
      return this.httpClient.get(Utility.serviceAddress + 'CustomerEmployee/CheckPermission', Utility.options('token'))
        .toPromise().then(result => plainToClassFromExist(new SingleResult<LoginResult>(LoginResult), result))
        .catch(result => plainToClassFromExist(new SingleResult<LoginResult>(LoginResult), result.error));
    else {
      const loginResult = new SingleResult<LoginResult>(LoginResult);
      loginResult.success = false;
      loginResult.message = 'UserIsNotLogin';
      return new Promise<SingleResult<LoginResult>>((resolve) => {
        resolve(loginResult);
      });
    }
  }
}
